export default __webpack_public_path__ + "static/media/create-thumbnail.aa18ac93.png";